import PropTypes from 'prop-types';

import Layout from 'components/Layout';

import Breadcrumb from './Breadcrumb';
import CategoriesCarousel from './CategoriesCarousel';
import DynamicallyLoadedSidebar from './DynamicallyLoadedSidebar';
import Head from './Head';
import Heading from './Heading';
import ThreadsList from './ThreadsList';

import FORUM from 'constants/forum';

const ForumPage = ({
  category: { categoryDescription, categorySlug, categoryTitle } = {
    categoryTitle: null,
    categorySlug: null,
  },
  gaEventCategory,
  serverThreads,
  threadsCategories,
  threadsPage,
}) => (
  <>
    <Head />
    <Layout
      headingComponent={
        <div>
          <Breadcrumb
            categoryTitle={
              categoryTitle === FORUM.RECENT_THREADS_METADATA.categoryTitle
                ? null
                : categoryTitle
            }
          />
        </div>
      }
      withGridLayout={false}
      maxWidthOnMobileDevices
    >
      <div className="mb-14 grid grid-cols-4 gap-x-4 md:grid-cols-12">
        <section className="col-span-4 row-start-3 md:col-span-full md:row-start-1">
          <CategoriesCarousel
            gaEventCategory={gaEventCategory}
            threadsCategories={threadsCategories}
          />
        </section>
        <section className="col-span-4 row-start-1 md:col-span-full md:row-start-2">
          <Heading description={categoryDescription} title={categoryTitle} />
        </section>
        <section className="col-span-4 row-start-2 max-w-full md:col-span-12 md:row-start-3 xl:col-span-9">
          <ThreadsList
            basePaginationSlug={categorySlug}
            categoryTitle={categoryTitle}
            gaEventCategory={gaEventCategory}
            serverThreads={serverThreads}
            threadsPage={threadsPage}
          />
        </section>
        <DynamicallyLoadedSidebar gaEventCategory={gaEventCategory} />
      </div>
    </Layout>
  </>
);

ForumPage.propTypes = {
  category: PropTypes.shape({
    categoryTitle: PropTypes.string,
    categorySlug: PropTypes.string,
  }),
  gaEventCategory: PropTypes.string.isRequired,
  serverThreads: PropTypes.shape({
    after: PropTypes.string,
    sort: PropTypes.string,
    before: PropTypes.string,
    total: PropTypes.number.isRequired,
    threads: PropTypes.arrayOf(
      PropTypes.shape({
        threadCategoryId: PropTypes.number,
        threadCategoryName: PropTypes.string,
        threadCategorySlug: PropTypes.string.isRequired,
        threadComments: PropTypes.number.isRequired,
        threadDislikes: PropTypes.number.isRequired,
        threadId: PropTypes.number.isRequired,
        threadLikes: PropTypes.number.isRequired,
        threadPublished: PropTypes.string.isRequired,
        threadReviewed: PropTypes.string,
        threadSlug: PropTypes.string,
        threadSolved: PropTypes.bool.isRequired,
        threadStatus: PropTypes.number.isRequired,
        threadStatusName: PropTypes.string.isRequired,
        threadTitle: PropTypes.string.isRequired,
        threadType: PropTypes.number.isRequired,
        threadTypeName: PropTypes.string.isRequired,
        threadUpdated: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  threadsCategories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number.isRequired,
      categorySlug: PropTypes.string.isRequired,
      categoryTitle: PropTypes.string.isRequired,
    })
  ).isRequired,
  threadsPage: PropTypes.number.isRequired,
};

export default ForumPage;
